import { EdgeItemType } from 'data/types';
import { openingBarRectOnRun, openingBarStyle } from 'utils/opening-layout';
import { runFrame } from 'utils/opening-position';
import { OpeningPlacementType } from 'utils/opening-position-types';
import {
  OPENING_DROP_PREVIEW_OPACITY,
  openingBarColor
} from 'utils/opening-visuals';
import OpeningDecoration from './opening-decoration';

type OpeningDropPreviewProps = {
  placement: OpeningPlacementType;
  itemType: EdgeItemType['type'];
  widthFt: number;
};

export default function OpeningDropPreview({
  placement,
  itemType,
  widthFt
}: OpeningDropPreviewProps) {
  const rect = openingBarRectOnRun(placement.run, placement.offsetFt, widthFt);
  const { inwardSign } = runFrame(placement.run);

  return (
    <div
      aria-hidden='true'
      className='absolute rounded-sm'
      style={{
        ...openingBarStyle(rect),
        backgroundColor: openingBarColor(itemType),
        opacity: OPENING_DROP_PREVIEW_OPACITY,
        pointerEvents: 'none',
        zIndex: 2
      }}
    >
      <OpeningDecoration
        itemType={itemType}
        lengthPx={rect.width}
        thicknessPx={rect.height}
        inwardSign={inwardSign}
      />
    </div>
  );
}
